import { useTableActionContext } from '@aibees/elephant/context';
import { SearchType } from '@aibees/elephant/types';
import { format } from 'date-fns';
import { useMemo } from 'react';

const FILE_NAMES = {
  [SearchType.Company]: 'Account Export',
  [SearchType.People]: 'Contact Export',
};

export function useDefaultFileName() {
  // Use the flow's effective search type (folds in the ActionButton override) so
  // the default name matches the record, not just the page route — e.g. a person
  // opened from the employees sidebar on a company search page.
  const { effectiveSearchType } = useTableActionContext();

  return useMemo(() => {
    const todayDate = format(new Date(), 'MMM dd');
    const baseName =
      FILE_NAMES[effectiveSearchType] ?? FILE_NAMES[SearchType.Company];

    return `${baseName}-${todayDate}`;
  }, [effectiveSearchType]);
}
